<div class="font-bold text-center text-sm w-full h-full items-center flex flex-col justify-center gap-2">
    <div class="grid grid-cols-1 w-20 h-20 rounded-full bg-card place-items-center">
        <img class="w-16 col-start-1 row-start-1" src="assets/images/logo/logo.svg" alt="Logo image">
        <mat-progress-spinner
            [strokeWidth]="strokeWidth"
            [diameter]="diameter"
            [mode]="mode"
            [value]="progress"
            class="col-start-1 row-start-1">
        </mat-progress-spinner>
    </div>

    <div>{{text}}</div>
</div>
